<template>
  <div class="class-item" :class="courseClass" @click.prevent="handleClick">
    <a :href="courseLink">
      <div class="class-pic">
        <!-- 顯示課程狀態標籤 -->
        <span class="class-tag badge" :class="specStatusClass">{{ specStatusTitle }}</span>
        <!-- 顯示課程圖片 -->
        <img :src="picUrl" @error="handleImageError" alt="course image" />
        <div class="class-line">
          <!-- 收藏課程按鈕 -->
          <div class="favorite-form">
            <button :class="favoriteButtonClass" @click="changeFavorite">
              <img :src="computedLoveIcon" alt="add to favorites" />
            </button>
          </div>
          <!-- 評價顯示 -->
          <div class="evaluation">
            <span class="star-icon"><img :src="computedStarIcon" alt="star rating" /></span>
            <span>{{ formattedRating }}</span>
            <span>({{ ratingCount }})</span>
          </div>
        </div>
      </div>
      <!-- 課程相關資訊 -->
      <div class="class-info">
        <!-- 顯示課程類型圖標和標籤 -->
        <div class="class-icon">
          <span v-show="courseAttributes.icon" class="class-icon-pic">
            <img :src="courseAttributes.icon" alt="icon" />
          </span>
          <span v-show="courseAttributes.label">{{ courseAttributes.label }}</span>
        </div>
        <!-- 顯示課程價格 -->
        <span v-show="courseAttributes.priceText" class="class-price">{{ courseAttributes.priceText }}</span>
        <!-- 顯示課程名稱 -->
        <h3 class="class-title" v-if="pageType == 'list'">{{ name }}</h3>
        <h4 class="class-title" v-else>{{ name }}</h4>
        <input type="hidden" class="type_id_specId_key" :data-type_id_specId_key="typeIdSpecIdKey" name="type_id_specId_key[]" :value="typeIdSpecIdKey">
        <!-- 顯示目標購買人數 -->
        <span v-show="courseAttributes.aimsText" class="aims">{{ courseAttributes.aimsText }}</span>
        <!-- 顯示已購買人數 -->
        <span class="purchaser">{{ courseAttributes.purchaserText }}</span>
        <!-- 進度條顯示 (例如: 募資進度) -->
        <div v-show="courseAttributes.progressbarWidth" class="progress" style="height: 5px">
          <div
              class="progress-bar"
              role="progressbar"
              :style="courseAttributes.progressbarWidth"
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
              tabindex="0"
              data-toggle="tooltip"
              title="0%"
          ></div>
        </div>
      </div>
    </a>
  </div>
</template>

<style scoped lang="scss">
$maincolor:#72ca4a;
$smallstandard:#555;
$bigstandard: #333;
$character: #666;
$bgcolor: #eee;

.class-item {
    display: block;
    &:hover {
        .class-pic {
            img {
                transform: scale(1.1);
                transition: 0.3s;
            }
        }
    }
    &.fundraising {
        .class-pic {
            .class-tag {
                border: 1px solid $maincolor;
                color: $maincolor;
                background: transparent;
            }
        }
        .class-info {
            background: $bgcolor;
            .class-icon {
                color: $character;
            }
            .class-price {
                color: $maincolor;
            }
            .class-title {
                color: $bigstandard;
            }
            .aims {
                flex: 0 0 50%;
                color: $smallstandard;
            }
            .purchaser {
                flex: 0 0 50%;
                color: $smallstandard;
            }
            .progress {
                width: 100%;
            }
        }
    }
    .class-pic {
        position: relative;
        overflow: hidden;
        max-height: 176px;
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
        }
        img {
            transform: scale(1);
            transition: 0.3s;
        }
        .class-line {
            position: absolute;
            bottom: 1rem;
            left: 2rem;
            display: flex;
            align-items: center;
            width: calc(100% - 4rem);
            z-index: 1;
            .class-collet {
                border: 0;
                width: 35px;
                height: 35px;
                padding: 8px 7px;
                border-radius: 100%;
                background: white;
                transition: 0.3s;
                &:hover,
                &.added {
                    img {
                        transition: 0.3s;
                        background: url(../img/pic/love_green.svg) no-repeat;
                        background-size: contain;
                    }
                }
            }
            .evaluation {
                color: white;
                flex: 1;
                text-align: right;
                .star-icon {
                    width: 15px;
                    line-height: 13px;
                    display: inline-block;
                    margin-right: 0.5rem;
                }
            }
        }
    }
    .class-info {
        display: flex;
        background: $maincolor;
        color: white;
        flex-wrap: wrap;
        align-items: center;
        padding: 1.5rem 2rem;
        border-top: 1px solid #ccc;
        min-height: 165px;
        .class-icon {
            flex: 0 0 50%;
            margin-bottom: 0.5rem;
            .class-icon-pic {
                display: inline-block !important;
                width: 20px;
                line-height: 20px;
                margin-right: 0.5rem;
            }
        }
        .class-price {
            flex: 0 0 100%;
            margin-bottom: 0.5rem;
            text-align: left;
            font-size: 14px;
            font-weight: 600;
            @media (max-width: 767px){
                font-size: 12px;
            }
        }
        .class-title {
            flex: 0 0 100%;
            font-size: 16px;
            line-height: 1.4;
            margin-bottom: 0.5rem;
            color: white;
            height: calc(16px * 2 * 1.4);
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
            overflow: hidden;
            @media (max-width: 1367px) {
                font-size: 14px;
                height: calc(14px * 2 * 1.4);
            }
        }
        .purchaser {
            flex: 0 0 100%;
            line-height: 25px;
            text-align: right;
        }
    }
    .badge-success{
        background-color: #72ca4a !important;
        color: white !important;
    }
    .btn-primary {
        height: 100%;
        width: 95%;
        background: $maincolor;
        color: white;
        flex: 1;
        margin-right: 1rem;
        font-size: 15px;
        transition: 0.3s;
        line-height: 2.5;

        &:hover {
            background: lighten($maincolor, 10%);
            transition: 0.3s;
            border-color: #91d671;
        }
    }
    .owl-dots {
        text-align: center;
        margin-top: 2rem;
        button.owl-dot {
            width: 10px;
            height: 10px;
            background: #dddddd;
            border-radius: 5px;
            display: inline-block;
            margin: 0 10px;
            @media (max-width: 1025px) {
                width: 8px;
                height: 8px;
            }
            &.active {
                background: #888;
            }
        }
    }
}
</style>
<script>
import Datalayer from 'Controllers/Web/Datalayer';

export default {
  props: {
    addFavoriteUrl: {
      type: String,
      default: '',
    },
    pageName: {
      type: String,
      default: '',
    },
    pagePosition: {
      type: String,
      default: '',
    },
    courseLink: {
      type: String,
      default: '',
    },
    picUrl: {
      type: String,
      default: '',
    },
    rating: {
      type: Number,
      default: 0,
    },
    isFree: {
      type: Number,
      default: 0,
    },
    minPrice: {
      type: Number,
      default: 0,
    },
    maxPrice: {
      type: Number,
      default: 0,
    },
    favoriteAdded: {
      type: Boolean,
      defalut: false,
    },
    specStatus: {
      type: Number,
      default: 1,
    },
    wishOrderActive: {
      type: Number,
      default: 0,
    },
    targetSalesCount: {
      type: Number,
      default: 0,
    },
    currentSalesCount: {
      type: Number,
      default: 0,
    },
    limitedSalesStartDate: {
      type: String,
      default: '',
    },
    limitedSalesEndDate: {
      type: String,
      default: '',
    },
    ratingCount: {
      type: Number,
      default: 0,
    },
    course: {
      type: Object,
      default: () => {},
    },
    pageType: {
      type: String,
      default: '',
    },
    typeIdSpecIdKey: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      favoriteAddedData: false, // 初始設定使用者是否已收藏課程
      formatRating: 0,
      currentSpecStatus: 1,
      courseType: 1,
      specStatusAttr: [
        {
          title: '待販售',
          class: 'badge-warning',
        },
        {
          title: '開課中',
          class: 'badge-success',
        },
        {
          title: '已完售',
          class: 'badge-danger',
        },
        {
          title: '募資中',
          class: 'badge-success',
        },
        {
          title: '許願中',
          class: 'badge-warning',
        },
      ],
      courseSaleType: 'simple',
      computedLoveIcon: 'img/pic/love.svg',
      computedStarIcon: 'img/pic/star.png',
      name: '',
    };
  },
  computed: {
    courseClass() {
      if(this.courseSaleType !== 'simple'){
        return 'fundraising';
      }
    },
    favoriteButtonClass: function () {
      return {
        'class-collet': true,
        added: this.favoriteAddedData,
      };
    },
    salesTimePercent() {
      // 如果 targetSalesCount 為 0
      if (this.targetSalesCount === 0) {
        return 0;
      }

      // 假定 baseSalesCount 是你的Vue屬性，因為你在原始PHP中使用了baseSalesTime
      let totalSales = this.currentSalesCount;

      // 如果 totalSales 為 0
      if (totalSales === 0) {
        return 0;
      }

      // 如果 totalSales 小於 targetSalesCount 的 1%
      if (totalSales < (this.targetSalesCount / 100)) {
        return 1;
      }
      // 返回百分比
      return Math.floor((totalSales / this.targetSalesCount) * 100);
    },
    courseAttributes() {
      const courseLabels = {
        1: '實體課程',
        2: '線上課程',
        3: '合購課程',
      };
      const label = courseLabels[this.courseType] || '實體課程';
      const fileName = this.courseSaleType === 'simple' ? '.png' : '-bl.png';
      const iconType = this.courseType === 1 ? 'entity' : 'video';

      const attributes = {
        icon: `img/pic/${iconType}${fileName}`,
        label,
        purchaserText: null,
        aimsText: null,
        priceText: null,
        progressbarWidth: null,
      };

      if(this.courseSaleType === 'simple' || this.courseSaleType === 'crowdfunding'){
        attributes.purchaserText = `${this.currentSalesCount} 人 已購買`;
        if(this.isFree == 1){
          attributes.priceText = '免費';
        }else if(this.minPrice != 0){
          attributes.priceText = this.minPrice === this.maxPrice ? `NT$ ${this.minPrice}` : `NT$ ${this.minPrice} ~ ${this.maxPrice}`;
        }
      }

      const width = this.salesTimePercent > 100 ? 100 : this.salesTimePercent;
      switch (this.courseSaleType){
        case 'crowdfunding':
          attributes.aimsText = `目標 ${this.targetSalesCount} 人`;
          attributes.progressbarWidth = `width: ${width}%`;
          break;
        case 'wishOrder':
          attributes.purchaserText = `${this.currentSalesCount} 人 已許願`;
          attributes.aimsText = `目標 ${this.targetSalesCount} 人`;
          attributes.progressbarWidth =  'width:' + width + '%';
          break;
      }
      return attributes;
    },
    specStatusClass() {
      return this.specStatusAttr[this.currentSpecStatus].class;
    },
    specStatusTitle() {
      return this.specStatusAttr[this.currentSpecStatus].title;
    },
    formattedRating() {
      return this.rating.toFixed(1);
    }
  },
  mounted() {
    if (this.formatRating !== 0) {
      this.formatRating = this.rating.toFixed(1);
    }
    this.courseType = this.course.courseType;
    this.name = this.course.name;
  },
  methods: {
    async handleClick(event) {
      if(this.pagePosition !== '' || this.pageName !== ''){
        event.preventDefault();
        const position = `${this.pageName}_course_${this.pagePosition}`;
          Datalayer.storeDatalayerEvent(this.name, position).catch((error) => {
              console.error('Datalayer event error:', error);
          });
      }
      window.location.href = this.courseLink;
    },
    handleImageError(event) {
      // 當圖片加載失敗時的處理函數
      event.target.src = 'img/pic/no_image_icon.png';
    },
    async changeFavorite() {
      // 切換課程收藏狀態
      this.favoriteAddedData = !this.favoriteAddedData;

      try {
        const response = await axios.post(this.addFavoriteUrl);

        if (response.data.status === 'not login') {
          this.$router.push('user/login');
          Message.show('請先登入會員');
          return;
        }

        Message.show(response.data.favoriteAdded ? '已經加入喜愛課程' : '已經從喜愛課程中移除');
        this.favoriteAddedData = response.data.favoriteAdded;

      } catch (error) {
        console.warn(error);
      }
    },
  },
  created: function () {
    // 初始化狀態設定
    this.favoriteAddedData = this.favoriteAdded;
    this.formatRating = this.rating.toFixed(1);
    this.currentSpecStatus = this.specStatus;

    let now = new Date(); // 獲取當前日期和時間

    // 判斷課程銷售類型 (募資中、許願中)
    if (this.wishOrderActive === 1) {
      this.currentSpecStatus = 4;
      this.courseSaleType = 'wishOrder';
    } else if (this.limitedSalesEndDate) {
      this.currentSpecStatus = 3;
      this.courseSaleType = 'crowdfunding';
    }
  },
};
</script>
